import Router from 'vue-router'
import Vue from 'vue'
import store from '@/store'
import assist from '@/utils/commonality'
Vue.use(Router)

//  先注释掉  忘记了是干什么的了
const originalPush = Router.prototype.push 
Router.prototype.push = function push(location) {
  return originalPush.call(this,location).catch(err => err)
}

import Home from '@/view/home'
const router =  new Router({
  // mode: "history", 
  routes :[
  { 
    path:'/',
    component:Home,
    children:[
      {
        path:'/about',
        component:() => import('@/view/about.vue')
      },
      {
        path:'/',
        component:() => import('@/view/homenr.vue')
      },
      {
        path:'/transcribe',
        component:() => import('@/view/luping.vue')
      },
      {
        path:'/imgedit',
        component:() => import('@/view/imgbianji.vue')
      },
      {
        path:'/spellimage',
        component:() => import('@/view/pintu.vue')
      }
    ]
    // children:[ //子路由模板
    //   {
    //     path:'/',
    //     component:introduce,
    //   },
    //   // { //子路由中的子路由模板
    //   //   path:'/feature',
    //   //   component:() => import('@/view/feature.vue'),
    //   //   children:[
    //   //     {
    //   //       path:'/feature',
    //   //       component:() => import('@/view/features/zh.vue'),
    //   //     },
    //   //   ]
    //   // },
    // ]
  },
 
  // {
  //   path:'/lianxi',
  //   component:() => import('@/view/lianxi.vue')
  // }


  ]


})


// 路由前置守卫
router.beforeEach((to,from,next) => {
    if (to.fullPath ==='/') {
      store.commit('updatetopactive',1)
    }else if (to.fullPath ==='/transcribe') {
      store.commit('updatetopactive',2)
    }else if (to.fullPath ==='/imgedit') {
      store.commit('updatetopactive',3)
    }else if (to.fullPath ==='/spellimage') {
      store.commit('updatetopactive',4)
    }else if (to.fullPath ==='/about') {
      store.commit('updatetopactive',5)
    }else {
      store.commit('updatetopactive',null)
    }

   next()
})


// 路由后置守卫
// router.afterEach((to,from) => {
//   // console.log(to);
//   // console.log(from);
// })



export default  router